import React, { useEffect } from "react";

export const About = (props) => {
  // useEffect(() => {
  //   var modal = document.getElementById("myModal");

  //   var img = document.getElementById("myImg");
  //   var modalImg = document.getElementById("img01");
  //   var captionText = document.getElementById("caption");
  //   img.onclick = function(){
  //     modal.style.display = "block";
  //     modalImg.src = this.src;
  //     modalImg.style.width = "80%";
  //     modalImg.style.height = "80%";
      
  //     captionText.innerHTML = this.alt;
  //   }

  //   var span = document.getElementsByClassName("close")[0];

  //   modal.onclick = function() { 
  //     modal.style.display = "none";
  //   }
  // }, [])

  return (
    <div id="about">
      {/* <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <img class="modal-content" id="img01"/>
        <div id="caption"></div>
      </div> */}
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <a target="_blank" href='img/about.png'>
              <img id="myImg" src="img/about.png" alt="About" style={{width: '100%'}} />
            </a>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About</h2>
              {/* <p>{props.data ? props.data.paragraph : "loading..."}</p> */}
              {props.data ? props.data.paragraph.map((para) => <p>{para}</p>) : <p>loading...</p>}
              {/* <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
